const Footer = () => {
    
            return (
                    <div className="footer">
                        <p> Made by Aaron, Gigi, Slava, Victoria at Juno College 2022</p>
                        <a href="https://www.freepik.com/vectors/watercolor-wallpaper">Watercolor wallpaper vector created by freepik - www.freepik.com </a>
                        | 
                        <a href="https://www.freepik.com/vectors/border"> Border vector created by pch.vector - www.freepik.com</a>
                    </div>
                
            );
}

export default Footer;
